// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__32niV","blockingNotification":"Notification_blockingNotification__2lQ34","spin360":"Notification_spin360__3Rlxc"};